import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ymy9myk6jv: FaireBrandEntity = {
  token: "b_ymy9myk6jv",
  type: "brand",
  name: "Kandlery",
  avatarUrl:
    "https://cdn.faire.com/fastly/edd10b0c340ef34d64888256f019dd60615a3f5f35f353b7906700ca33bbbb8d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f466985eb2eba72d05b2e12d9929fb302030f61bf6a9b34a4659a39dceda9d16.png",
  logoUrl:
    "https://cdn.faire.com/fastly/edd10b0c340ef34d64888256f019dd60615a3f5f35f353b7906700ca33bbbb8d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f466985eb2eba72d05b2e12d9929fb302030f61bf6a9b34a4659a39dceda9d16.png",
  location: "Austin, TX, USA",
  minimumOrderDollars: 75,
  rating: 5,
  reviewCount: 28,
  isTopShop: true,
  isInsider: true,
  description:
    "Kandlery crafts hand-poured, eco-conscious candles with unique Asian-inspired scents, specifically designed for the busy professional. Our mission is to create non-toxic and clean home fragrance product lines that represent untapped Asian-inspired scents in the U.S. candle market.\n\nOur candles are made using a high-quality blend of natural coconut apricot wax, complemented by beautiful wooden wicks, and a selection of custom-made fragrance oils that are safe and free from harmful chemicals. We also offer natural room sprays and coconut wax melts, ensuring a safe, chemical-free fragrance experience.\n\nProudly 'Made Better Certified'.\nOur goal is to source supplies with the highest quality standards in mind.\n\nKandlery is also a woman, AAPI and immigrant-owned business.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:18.979Z",
    importedBy: "entity-db-cli",
  },
};
